export class UnitOfMeasurement {
  unitOfMeasurementId!: number;
  unitName!: string;
  constructor(source: Partial<UnitOfMeasurement>) {
    Object.assign(this, source);
  }
}
